// extracted by mini-css-extract-plugin
export var headerCell = "_1r-1";
export var loadingSpinnerContainer = "_1r-4";
export var rowWrapper = "_1r-3";
export var standaloneTable = "_1r-5";
export var table = "_1r-0";
export var white = "_1r-2";